// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/henkel/Henkel-GT-Flexa-Standard/Henkel-GT-Flexa-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/segoeUI/SegoeUI-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
	font-weight: bold;
	font-size: 18px;
}

html,
body,
#root {
	height: 100%;
}

body {
	margin: 0;
	font-family: 'SegoeUI', 'Helvetica Neue', sans-serif;
}

.css-dev-only-do-not-override-1v28nim.ant-form-item .ant-form-item-label > label.ant-form-item-required::before {
	font-size: 12px !important;
}

.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown
	.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(
		.ant-picker-cell-range-end
	)::before,
.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown
	.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-start-single):not(
		.ant-picker-cell-range-start
	)::before,
.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
	background-color: #efe6fc !important;
}

@font-face {
	font-family: 'Henkel GT Flexa';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('otf');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'SegoeUI-SemiBold';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
	font-weight: 600;
	font-style: normal;
	font-display: swap;
}

/********** App  common styles ************/

.card-container {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 24px;
}

.app-page-container {
	display: flex;
	flex: 1 1;
	flex-direction: column;
	padding: 0px 12px;
	min-width: 860px;
	height: 100%;
	overflow: hidden;
}

.app-navbar {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 8px 0px;
	align-items: center;
}

.app-navbar-text {
	font-family: 'Henkel GT Flexa', sans-serif;
	font-weight: 700;
	font-style: Bold;
	font-size: 28px;
	line-height: 48px;
	letter-spacing: 0px;
	vertical-align: middle;
}

.app-navbar-select {
	display: flex;
	flex-direction: column;
	padding: 8px 0px;
}

.app-section {
	display: flex;
	flex-direction: column;
	flex: 1 1;
}
.app-section-header {
	display: flex;
	align-items: center;
	background-color: #e0f6f8;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	height: 40px;
	margin-bottom: 24px;
	padding: 0px 12px;
	border-radius: 4px;
}

.app-btn {
	cursor: pointer;
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	font-weight: 550;
	line-height: 1;
	letter-spacing: 0em;
	padding: 9px 24px;
}

.app-btn-primary {
	color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	border-radius: 17px;
	background: #5f09e0;
	padding: 8px 16px;
	border: 1px solid #5f09e0;
}

.app-btn-icon {
	width: 16px;
	height: 16px;
}

.app-btn-primary:hover {
	background: #af84ef;
	border: 1px solid #af84ef;
}

.app-btn-primary:active {
	background: #5f09e0;
	border: 1px solid #5f09e0;
}

.app-btn-edit {
	color: #000000;
	display: inline-flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	border-radius: 17px;
	border: 1px solid #696969;
	white-space: nowrap;
}

.app-btn-delete {
	color: #b10000;
	display: inline-flex;
	padding: 6px 12px;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	border: 1px solid #b10000;
	white-space: nowrap;
}

.app-btn-submit {
	border-radius: 8px;
}

.app-btn-delete:hover {
	border: 1px solid #e10101;
	color: #e10101;
}

.app-btn-delete:active {
	border: 1px solid #b10000;
	color: #b10000;
}

.app-btn-delete-modal {
	color: #ffffff;
	display: inline-flex;
	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	background-color: #b10000;
	border: 1px solid #b10000;
	white-space: nowrap;
}

.app-btn-delete-modal:hover {
	background-color: #e10101;
	border: 1px solid #e10101;
}

.app-btn-delete-modal:active {
	background-color: #b10000;
	border: 1px solid #b10000;
}

.app-btn-padding {
	padding: 8px 16px;
}

.app-group {
	max-height: 310px;
	padding-right: 28px;
	overflow-y: auto;
	overflow-x: visible;
}

.app-cursor {
	cursor: pointer;
}

.app-checkbox-wrapper {
	margin-bottom: 16px;
	display: flex;
	align-items: center;
}

.app-checkbox-title {
	width: 130px;
	margin-right: 4px;
	margin-left: 8px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.app-selected-number-title {
	margin-left: 16px;
	color: rgba(0, 0, 0, 0.5);
	font-family: 'Segoe UI', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 27px;
}

.app-btn-disabled {
	color: white;
	display: inline-flex;
	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	background-color: #efe6fc;
	white-space: nowrap;
	cursor: not-allowed;
	pointer-events: none;
	border: none;
}

#loading {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(255, 255, 255, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	font-size: 20px;
	margin: 0;
	padding: 0;
	pointer-events: none;
}

.app-product-input-category-con .ant-form-item {
	margin-bottom: 1px !important;
}

.ant-upload-wrapper .ant-upload-drag .ant-upload {
	padding: 0 !important;
}

.app-display-none {
	display: none;
}

.app-page-container-cookie {
	position: fixed;
	z-index: 100000;
	top: 0;
	left: 30%;
	width: 595px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	background: #fff;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
	padding: 32px;
	color: rgba(0, 0, 0, 0.75);
	font-family: 'Segoe UI', sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: 24px;
}

.app-page-container-cookie-button {
	padding: 8px 16px;
	color: #fff;
	text-align: center;
	font-family: 'Inter', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #69008c;
	border-radius: 8px;
	margin-top: 30px;
	margin-right: 20px;
}

.app-page-container-cookie-button:hover,
.app-page-container-cookie-button:focus {
	background: rgba(105, 0, 140, 0.4) !important;
	border: none !important;
}

.app-page-container-cookie-button:active {
	background-color: #69008c !important;
	border: none !important;
}

.app-page-container-cookie-button-con {
	display: flex;
	justify-content: flex-end;
	margin-top: 32px;
}

.app-btn-cookies-margin {
	margin-right: 24px;
}

.app-table-imgPath .ant-table-wrapper .ant-table-tbody > tr > th,
.app-table-imgPath .ant-table-wrapper .ant-table-tbody > tr > td {
	padding: 0px 16px !important;
	line-height: 67px !important;
}

.app-table {
	display: flex;
	flex-direction: column;
	flex: 1 1;
}

.app-table-content {
	background: #ffffff;
	border-radius: 4px;
	flex: 1 1;
	padding: 8px 8px 0 8px;
	overflow: hidden;
}

.app-page-container-cookie-display-none {
	display: none;
}

.app-btn-min-width {
	min-width: 72px;
}

.app-search-select-style {
	height: 35px;
	width: 200px;
	margin-right: 32px;
	margin-bottom: 10px;
}

.app-list-date-style {
	margin-bottom: 2px;
	white-space: nowrap;
}

.app-modal-common {
	box-shadow: none;
	height: auto;
}

.app-box-cursor-common {
	cursor: pointer;
}

.cursor-default-com {
	cursor: default;
}

.ant-table .ant-checkbox-checked:hover .ant-checkbox-inner {
	background-color: #6c5ce7 !important;
	border-color: #6c5ce7 !important;
}

.app-category {
	margin-top: 32px;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 32px;
}

.app-category-new {
	margin-top: 18px;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 24px;
}

.app-category-title-con {
	text-align: center;
	font-family: 'Segoe UI', sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	height: 31px;
	width: 100px;
	margin-right: 24px;
	color: rgba(0, 0, 0, 0.25);
}

.app-category-title-border {
	border-bottom: 2px solid #5f09e0;
	color: #5f09e0;
}

.app-professional {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.app-margintop {
	margin-top: -15px;
}

.app-search-select-margin-top {
	margin-top: 24px;
}

.table-line-all {
	width: 100%;
	border-top: 1px solid #e5e5e5;
}

.app-delete-modal {
	padding-top: 32px;
	color: #000;
	font-family: 'Segoe UI', sans-serif;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	padding-right: 32px;
}

.action-icon-size-all-con {
	width: 40px;
	height: 40px;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.action-icon-size-all {
	width: 24px;
	height: 24px;
}

.action-icon-size-all-con:hover {
	background: #eff3f6;
}

.action-btn-con {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}

/******** Filter styles *******/

.app-filter-section {
	background-color: #ffffff;
	padding: 16px 8px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.app-filter-section .filter-items-row {
	display: flex;
	gap: 24px;
	height: 32px;
	flex: 1 1;
}

.filter-actions {
	flex: 1 1;
	display: flex;
	justify-content: flex-end;
}

.flex-2 {
	flex: 2 1;
}

.filter-actions button {
	margin-right: 11px;
	display: inline-flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	border-radius: 17px;
}

.app-filter-section .filter-item {
	display: flex;
	min-width: 180px;
	justify-content: space-between;
	flex: 1 1;
	padding: 0px;
	flex-shrink: 0;
}

.app-filter-section .ant-picker-outlined {
	display: flex;
	flex: 1 1;
	min-width: 180px;
	border: 1px solid #b6b6b6 !important;
	border-radius: 8px;
}

.app-filter-section .text-input {
	padding: 0px 11px !important;
}
.app-filter-section .text-input .ant-input {
	padding: 0px !important;
	height: 32px !important;
}

.app-filter-section .filter-top-row .ant-select :nth-last-child {
	margin-right: 0px;
}

.app-filter-section .filter-bottom-row .ant-select-selector {
	border: none !important;
}

/********** antd styles override ************/

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
	color: #5f09e0 !important;
}
.ant-tabs .ant-tabs-ink-bar {
	background-color: #5f09e0 !important;
}

.ant-tabs .ant-tabs-tab:hover {
	color: #5f09e0 !important;
}

@media (max-width: 768px) {
	.ant-layout-sider {
		position: fixed !important;
		height: 100vh;
		z-index: 100;
	}

	.ant-layout {
		margin-left: 0 !important;
	}

	.ant-layout-header {
		padding: 0 16px !important;
	}
}

.ant-radio-wrapper .ant-radio-checked::after {
	border-color: #5f09e0 !important;
}

.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
	border-color: #5f09e0 !important;
	background-color: #5f09e0 !important;
}

.ant-checkbox-group .ant-row {
	margin-bottom: 8px;
}
.ant-checkbox-group .ant-row:first-child {
	margin-top: 8px;
}

.ant-upload-drag {
	background-color: #fff !important;
}

.ant-breadcrumb,
.ant-breadcrumb-link,
.ant-breadcrumb-link:hover {
	color: #000 !important;
	font-family: 'Segoe UI', sans-serif !important;
	font-size: 20px !important;
	font-style: normal !important;
	font-weight: 700 !important;
	line-height: normal !important;
	background-color: transparent !important;
}

.ant-breadcrumb .ant-breadcrumb-separator {
	color: #000 !important;
	padding: 0 !important;
	margin: 0px !important;
}

.ant-modal .ant-modal-content {
	border-radius: 4px !important;
	padding: 0 0 !important;
}

.ant-modal .ant-modal-header {
	display: flex !important;
	align-items: flex-start;
	padding: 24px 24px 0 32px !important;
}

.ant-modal .ant-modal-body {
	padding: 0 32px !important;
	margin: 48px 0 !important;
}

.ant-modal .ant-modal-close {
	top: 24px !important;
	right: 24px !important;
	width: 24px !important;
	height: 24px !important;
}

.ant-modal .ant-modal-close:hover {
	background: transparent !important;
}

.app-modal-close-btn {
	width: 24px;
	height: 24px;
}

.ant-modal .ant-modal-title {
	font-size: 32px !important;
	font-weight: 500 !important;
	font-style: Medium !important;
	color: #000 !important;
	vertical-align: middle !important;
	line-height: 28px !important;
	letter-spacing: 0px !important;
	font-family: 'Henkel GT Flexa', sans-serif !important;
}

.ant-form-item .ant-form-item-label {
	padding-bottom: 0px !important;
}

.ant-form-item .ant-form-item-label > label {
	height: 12px !important;
	margin: 0 !important;
	padding: 0 !important;
	color: #696969 !important;
	font-family: 'Segoe UI', sans-serif !important;
	font-size: 12px !important;
	font-weight: 400 !important;
	padding-left: 8px !important;
	line-height: 12px !important;
	padding-bottom: 4px !important;
}

.ant-form-item .ant-form-item-explain-error {
	font-family: 'Segoe UI', sans-serif !important;
	font-size: 12px !important;
	font-style: normal !important;
	font-weight: 400 !important;
	line-height: 12px !important;
	padding-left: 8px !important;
}

.ant-input {
	border-radius: 4px !important;
	height: 34px !important;
	box-shadow: none !important;
	padding: 10px 8px !important;
	font-family:
		Segoe UI,
		sans-serif !important;
	font-weight: 400 !important;
	font-style: Regular !important;
	font-size: 14px !important;
	line-height: 100%;
	letter-spacing: 0px !important;
	vertical-align: middle !important;
}

.ant-input-outlined {
	border: 1px solid #b6b6b6 !important;
}

.ant-input:placeholder-shown {
	color: #b5b5b5 !important;
}

.ant-input:hover,
.ant-input:focus {
	border-color: #5f09e0 !important;
	box-shadow: none !important;
}

.ant-input:focus {
	color: #000000 !important;
}
.ant-btn-color-purple.ant-btn-variant-solid {
	background-color: #5f09e0 !important;
}
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover,
.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {
	border-color: #cc3939 !important;
}

.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled) {
	border-color: #cc3939 !important;
}

.ant-form-item .ant-form-item-explain-error {
	color: #cc3939 !important;
}

.ant-form-item {
	margin-bottom: 18px !important;
}

.ant-modal .ant-modal-footer {
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	padding-bottom: 48px !important;
}

.app-btn-cancel-margin-right {
	margin-right: 48px;
}

.ant-pagination .ant-pagination-item {
	height: 32px !important;
	padding: 5px 12px !important;
	gap: 10px !important;
	border-radius: 2px !important;
	border: 1px solid #e4e7ed !important;
	background: #f5f7fa !important;
}

.ant-pagination .ant-pagination-item a {
	color: #909399 !important;
	text-align: center !important;
	font-family: 'Segoe UI', sans-serif !important;
	font-size: 14px !important;
	font-style: normal !important;
	font-weight: 400 !important;
	line-height: normal !important;
	padding: 0px !important;
}

.ant-pagination .ant-pagination-item-active {
	background-color: #ffffff !important;
	border-color: #5f09e0 !important;
}

.ant-pagination .ant-pagination-item-active a {
	color: #5f09e0 !important;
	font-weight: 700 !important;
}

.ant-pagination .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination .ant-pagination-next .ant-pagination-item-link {
	border: 1px solid #e4e7ed !important;
	background: #f5f7fa !important;
	border-radius: 2px !important;
}

.ant-pagination .ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {
	background-color: #f5f7fa !important;
	border-radius: 2px !important;
	border: 1px solid #e4e7ed !important;
}

.ant-select-single .ant-select-selector {
	border-radius: 8px !important;
	border: 1px solid var(--N2-Grey-696969, #696969) !important;
}

.css-dev-only-do-not-override-1v28nim.ant-picker-outlined {
	border-radius: 8px !important;
	height: 34px;
}

.ant-padding-new {
	padding: 8px 16px;
}

.ant-top-margin-top {
	margin-top: 32px;
}

.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown
	.ant-picker-cell-in-view.ant-picker-cell-in-range:hover::before {
	background-color: #e1d0fc !important;
}

.ant-table-wrapper .ant-table-tbody > tr > td {
	border-bottom: none !important;
	padding: 8px 16px !important;
	font-family:
		Segoe UI,
		sans-serif;
	font-weight: 400 !important;
	font-style: Regular !important;
	font-size: 14px !important;
	line-height: 100% !important;
	letter-spacing: 0px !important;
	vertical-align: middle !important;
	color: #3b3b3b !important;
}

.ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
	background: #fbf9f9 !important;
}

.ant-table-tbody .ant-table-row {
	height: 56px !important;
}

.ant-table-wrapper .ant-table {
	overflow: hidden !important;
}
.ant-table-header .ant-table-thead {
	background-color: #e0f6f8 !important;
}

.ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {
	width: 0px !important;
	padding: 0px !important;
}

table > thead > tr:first-child > .ant-table-cell-fix-right {
	border-start-end-radius: 4px !important;
	border-bottom-right-radius: 4px !important;
	text-align: center;
}

.ant-table-thead > tr {
	font-family: 'Segoe UI', 'sans-serif' !important;
	font-weight: 550 !important;
	font-style: Semibold !important;
	font-size: 12px !important;
	line-height: 100%;
	letter-spacing: 0px;
	text-align: center;
	vertical-align: middle;
	border-radius: 4px !important;
	height: 56px !important;
}

.ant-table-thead > tr > th {
	background: #e0f6f8 !important;
	padding: 12px 16px !important;
}

.ant-table-wrapper .ant-table-thead > tr > th,
.ant-table-wrapper .ant-table-thead > tr > td {
	border-bottom: none !important;
}

table > thead > tr:first-child > *:first-child {
	border-start-start-radius: 4px !important;
	border-bottom-left-radius: 4px !important;
}

.ant-table-measure-row {
	display: none !important;
}

.ant-table-row-selected {
	background-color: #fff !important;
}

.ant-table-tbody > tr.ant-table-row-selected td {
	background-color: #fff !important;
}

.ant-table-tbody > tr.ant-table-row-selected:hover td {
	background-color: #fff !important;
}

.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
	border: 1px solid #b6b6b6 !important;
	box-shadow: none !important;
}

.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover
	.ant-select-selector {
	border-color: #5f09e0 !important;
	box-shadow: none !important;
}

.ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(
		.ant-pagination-size-changer
	)
	.ant-select-selector {
	border-color: #5f09e0 !important;
	box-shadow: none !important;
}

.ant-select-dropdown {
	padding: 8px !important;
	font-family:
		Segoe UI,
		sans-serif !important;
	font-weight: 400 !important;
	font-style: Regular !important;
	font-size: 14px !important;
}

.ant-select-dropdown .ant-select-item {
	height: 36px !important;
	border-radius: 4px !important;
	margin-bottom: 4px;
}

.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
	background: #efe6fc !important;
	font-family:
		Segoe UI,
		sans-serif !important;
	font-weight: 400 !important;
	font-style: Regular !important;
	font-size: 14px !important;
}

.ant-select-dropdown
	.ant-select-item-option-selected:not(.ant-select-item-option-disabled)
	.ant-select-item-option-state {
	color: #5f09e0 !important;
}

.ant-select-outlined.ant-select-multiple .ant-select-selection-item {
	background: #eff3f6 !important;
	height: 26px !important;
	font-family:
		Segoe UI,
		sans-serif !important;
	font-weight: 400 !important;
	font-style: Regular !important;
	font-size: 14px !important;
	line-height: 24px !important;
	letter-spacing: 0% !important;
	vertical-align: middle !important;
	border-radius: 4px !important;
}

.ant-menu .ant-menu-submenu-title {
	border-radius: none !important;
}

.footer-main-con {
	min-height: calc(100vh - 80px);
	padding: 40px 100px 100px;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family:
		Segoe UI,
		sans-serif;
	font-weight: 400;
	font-style: Regular;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0%;
	color: #3b3b3b;
}

.footer-mian-top-icon {
	width: 88px;
	height: 65px;
	margin-bottom: 40px;
}

.footer-main-top-title {
	text-align: center;
	font-weight: 500;
	font-size: 20px;
	margin-bottom: 40px;
}

.footer-main-blod {
	font-weight: 700;
}

.footer-main-con ul,
.footer-main-con ol {
	margin-left: 20px;
}

.footer-main-con a {
	text-decoration: underline;
	color: #3b3b3b;
}

.footer-main-con a:hover {
	text-decoration: underline;
	color: #3b3b3b;
	font-weight: 500;
}

.ant-checkbox-checked .ant-checkbox-inner {
	background-color: #5f09e0 !important;
	border-color: #5f09e0 !important;
}
.ant-checkbox-checked .ant-checkbox-inner:after {
	background-color: #5f09e0 !important;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
	border-color: #5f09e0 !important;
}
.ant-checkbox .ant-checkbox-input:hover {
	border-color: #5f09e0 !important;
}
.ant-picker-ranges .ant-btn-variant-solid {
	background-color: #5f09e0 !important;
	border-color: #5f09e0 !important;
	color: #fff !important;
}
/* .ant-picker-range {
	height: 32px !important;
} */

.ant-picker-dropdown
	.ant-picker-time-panel-column
	> li.ant-picker-time-panel-cell-selected
	.ant-picker-time-panel-cell-inner {
	width: 140%;
	background-color: #e1d0fc !important;
	margin-left: -10px;
}
.ant-picker-outlined:hover {
	border-color: #5f09e0 !important;
}

.ant-picker-outlined:focus,
.ant-picker-outlined-focused,
.ant-picker-outlined:focus-within {
	border: 1px solid #5f09e0 !important;
	box-shadow: none !important;
	outline: none !important;
}

.ant-picker-outlined .ant-picker-input input::after {
	border-bottom-color: #5f09e0 !important;
}

.ant-picker-outlined .ant-picker-input-focused::after,
.ant-picker-outlined-focused .ant-picker-input::after {
	border-bottom-color: #5f09e0 !important;
	border-bottom-width: 2px !important;
}
.ant-picker-active-bar {
	background-color: #5f09e0 !important;
}
.ant-dropdown-menu-item img {
	width: 22px;
	height: 22px;
	margin-left: -2px;
}

.ant-tree .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
	background-color: #5f09e0 !important;
}

.ant-tree .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
	background-color: #5f09e0 !important;
	border-color: #5f09e0 !important;
}

.delete-confirm-modal .ant-modal-content .ant-modal-body {
	margin: 0px !important;
	padding: 32px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;;CAGC,YAAY;AACb;;AAEA;CACC,SAAS;CACT,oDAAoD;AACrD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;;;;;;;;CASC,oCAAoC;AACrC;;AAEA;CACC,8BAA8B;CAC9B,0DAAmG;CACnG,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,+BAA+B;CAC/B,+DAA0E;CAC1E,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA,2CAA2C;;AAE3C;CACC,aAAa;CACb,eAAe;CACf,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,SAAO;CACP,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;CAC1C,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAO;AACR;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,mCAAmC;CACnC,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,mCAAmC;CACnC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,oBAAoB;CACpB,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,YAAY;CACZ,aAAa;CACb,oCAAoC;CACpC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,eAAe;CACf,SAAS;CACT,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,eAAe;CACf,MAAM;CACN,SAAS;CACT,YAAY;CACZ,kBAAkB;CAClB,oCAAoC;CACpC,gBAAgB;CAChB,+CAA+C;CAC/C,aAAa;CACb,0BAA0B;CAC1B,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;CAEC,6CAA6C;CAC7C,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAO;AACR;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,SAAO;CACP,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;AACT;;AAEA,+BAA+B;;AAE/B;CACC,yBAAyB;CACzB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;CACT,YAAY;CACZ,SAAO;AACR;;AAEA;CACC,SAAO;CACP,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,8BAA8B;CAC9B,SAAO;CACP,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,aAAa;CACb,SAAO;CACP,gBAAgB;CAChB,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;AACxB;;AAEA,6CAA6C;;AAE7C;CACC,yBAAyB;AAC1B;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC;EACC,0BAA0B;EAC1B,aAAa;EACb,YAAY;CACb;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;CAChC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;;;CAGC,sBAAsB;CACtB,8CAA8C;CAC9C,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,8BAA8B;CAC9B,wCAAwC;AACzC;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;CAC7B,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CACxB,uBAAuB;CACvB,oCAAoC;AACrC;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,6BAA6B;CAC7B,sBAAsB;CACtB,iCAAiC;CACjC,4BAA4B;CAC5B,8BAA8B;CAC9B,qDAAqD;AACtD;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,uBAAuB;CACvB,oBAAoB;CACpB,qBAAqB;CACrB,yBAAyB;CACzB,8CAA8C;CAC9C,0BAA0B;CAC1B,2BAA2B;CAC3B,4BAA4B;CAC5B,4BAA4B;CAC5B,8BAA8B;AAC/B;;AAEA;CACC,8CAA8C;CAC9C,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;CAC7B,uBAAuB;CACvB,2BAA2B;CAC3B,4BAA4B;CAC5B;;uBAEsB;CACtB,2BAA2B;CAC3B,8BAA8B;CAC9B,0BAA0B;CAC1B,iBAAiB;CACjB,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,oCAAoC;AACrC;AACA;;CAEC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,kCAAkC;CAClC,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,4BAA4B;CAC5B,oBAAoB;CACpB,6BAA6B;CAC7B,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,8CAA8C;CAC9C,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;;CAEC,oCAAoC;CACpC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;;CAEC,oCAAoC;CACpC,6BAA6B;CAC7B,oCAAoC;AACrC;;AAEA;CACC,6BAA6B;CAC7B,2DAA2D;AAC5D;;AAEA;CACC,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,8BAA8B;CAC9B,4BAA4B;CAC5B;;YAEW;CACX,2BAA2B;CAC3B,8BAA8B;CAC9B,0BAA0B;CAC1B,4BAA4B;CAC5B,8BAA8B;CAC9B,iCAAiC;CACjC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;AACA;CACC,oCAAoC;AACrC;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,uCAAuC;CACvC,0CAA0C;CAC1C,kBAAkB;AACnB;;AAEA;CACC,gDAAgD;CAChD,2BAA2B;CAC3B,+BAA+B;CAC/B,0BAA0B;CAC1B,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;CACtB,6BAA6B;CAC7B,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;CACC,yCAAyC;CACzC,yCAAyC;AAC1C;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,oCAAoC;CACpC,2BAA2B;AAC5B;;AAEA;;CAEC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;;;;CAIC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;CACvB;;uBAEsB;CACtB,2BAA2B;CAC3B,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B;;uBAEsB;CACtB,2BAA2B;CAC3B,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;CACvB;;uBAEsB;CACtB,2BAA2B;CAC3B,8BAA8B;CAC9B,0BAA0B;CAC1B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;CACjC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB;;YAEW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,oCAAoC;AACrC;AACA;;;CAGC,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;AACA;CACC,oCAAoC;CACpC,gCAAgC;CAChC,sBAAsB;AACvB;AACA;;GAEG;;AAEH;;;;CAIC,WAAW;CACX,oCAAoC;CACpC,kBAAkB;AACnB;AACA;CACC,gCAAgC;AACjC;;AAEA;;;CAGC,oCAAoC;CACpC,2BAA2B;CAC3B,wBAAwB;AACzB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;CAEC,uCAAuC;CACvC,mCAAmC;AACpC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;CACtB,wBAAwB;AACzB","sourcesContent":[".logo {\n\tfont-weight: bold;\n\tfont-size: 18px;\n}\n\nhtml,\nbody,\n#root {\n\theight: 100%;\n}\n\nbody {\n\tmargin: 0;\n\tfont-family: 'SegoeUI', 'Helvetica Neue', sans-serif;\n}\n\n.css-dev-only-do-not-override-1v28nim.ant-form-item .ant-form-item-label > label.ant-form-item-required::before {\n\tfont-size: 12px !important;\n}\n\n.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown\n\t.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(\n\t\t.ant-picker-cell-range-end\n\t)::before,\n.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown\n\t.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-start-single):not(\n\t\t.ant-picker-cell-range-start\n\t)::before,\n.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {\n\tbackground-color: #efe6fc !important;\n}\n\n@font-face {\n\tfont-family: 'Henkel GT Flexa';\n\tsrc: url('./assets/fonts/henkel/Henkel-GT-Flexa-Standard/Henkel-GT-Flexa-Medium.otf') format('otf');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: 'SegoeUI-SemiBold';\n\tsrc: url('./assets/fonts/segoeUI/SegoeUI-SemiBold.ttf') format('truetype');\n\tfont-weight: 600;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n/********** App  common styles ************/\n\n.card-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 16px;\n\tmargin-bottom: 24px;\n}\n\n.app-page-container {\n\tdisplay: flex;\n\tflex: 1;\n\tflex-direction: column;\n\tpadding: 0px 12px;\n\tmin-width: 860px;\n\theight: 100%;\n\toverflow: hidden;\n}\n\n.app-navbar {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\tpadding: 8px 0px;\n\talign-items: center;\n}\n\n.app-navbar-text {\n\tfont-family: 'Henkel GT Flexa', sans-serif;\n\tfont-weight: 700;\n\tfont-style: Bold;\n\tfont-size: 28px;\n\tline-height: 48px;\n\tletter-spacing: 0px;\n\tvertical-align: middle;\n}\n\n.app-navbar-select {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 8px 0px;\n}\n\n.app-section {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n}\n.app-section-header {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: #e0f6f8;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 14px;\n\theight: 40px;\n\tmargin-bottom: 24px;\n\tpadding: 0px 12px;\n\tborder-radius: 4px;\n}\n\n.app-btn {\n\tcursor: pointer;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 14px;\n\tfont-weight: 550;\n\tline-height: 1;\n\tletter-spacing: 0em;\n\tpadding: 9px 24px;\n}\n\n.app-btn-primary {\n\tcolor: #fff;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\tborder-radius: 17px;\n\tbackground: #5f09e0;\n\tpadding: 8px 16px;\n\tborder: 1px solid #5f09e0;\n}\n\n.app-btn-icon {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.app-btn-primary:hover {\n\tbackground: #af84ef;\n\tborder: 1px solid #af84ef;\n}\n\n.app-btn-primary:active {\n\tbackground: #5f09e0;\n\tborder: 1px solid #5f09e0;\n}\n\n.app-btn-edit {\n\tcolor: #000000;\n\tdisplay: inline-flex;\n\tpadding: 12px 24px;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 17px;\n\tborder: 1px solid #696969;\n\twhite-space: nowrap;\n}\n\n.app-btn-delete {\n\tcolor: #b10000;\n\tdisplay: inline-flex;\n\tpadding: 6px 12px;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 4px;\n\tborder: 1px solid #b10000;\n\twhite-space: nowrap;\n}\n\n.app-btn-submit {\n\tborder-radius: 8px;\n}\n\n.app-btn-delete:hover {\n\tborder: 1px solid #e10101;\n\tcolor: #e10101;\n}\n\n.app-btn-delete:active {\n\tborder: 1px solid #b10000;\n\tcolor: #b10000;\n}\n\n.app-btn-delete-modal {\n\tcolor: #ffffff;\n\tdisplay: inline-flex;\n\tpadding: 8px 16px;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 4px;\n\tbackground-color: #b10000;\n\tborder: 1px solid #b10000;\n\twhite-space: nowrap;\n}\n\n.app-btn-delete-modal:hover {\n\tbackground-color: #e10101;\n\tborder: 1px solid #e10101;\n}\n\n.app-btn-delete-modal:active {\n\tbackground-color: #b10000;\n\tborder: 1px solid #b10000;\n}\n\n.app-btn-padding {\n\tpadding: 8px 16px;\n}\n\n.app-group {\n\tmax-height: 310px;\n\tpadding-right: 28px;\n\toverflow-y: auto;\n\toverflow-x: visible;\n}\n\n.app-cursor {\n\tcursor: pointer;\n}\n\n.app-checkbox-wrapper {\n\tmargin-bottom: 16px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.app-checkbox-title {\n\twidth: 130px;\n\tmargin-right: 4px;\n\tmargin-left: 8px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.app-selected-number-title {\n\tmargin-left: 16px;\n\tcolor: rgba(0, 0, 0, 0.5);\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 27px;\n}\n\n.app-btn-disabled {\n\tcolor: white;\n\tdisplay: inline-flex;\n\tpadding: 8px 16px;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 8px;\n\tbackground-color: #efe6fc;\n\twhite-space: nowrap;\n\tcursor: not-allowed;\n\tpointer-events: none;\n\tborder: none;\n}\n\n#loading {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground: rgba(255, 255, 255, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 9999;\n\tfont-size: 20px;\n\tmargin: 0;\n\tpadding: 0;\n\tpointer-events: none;\n}\n\n.app-product-input-category-con .ant-form-item {\n\tmargin-bottom: 1px !important;\n}\n\n.ant-upload-wrapper .ant-upload-drag .ant-upload {\n\tpadding: 0 !important;\n}\n\n.app-display-none {\n\tdisplay: none;\n}\n\n.app-page-container-cookie {\n\tposition: fixed;\n\tz-index: 100000;\n\ttop: 0;\n\tleft: 30%;\n\twidth: 595px;\n\tborder-radius: 4px;\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\tbackground: #fff;\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);\n\tpadding: 32px;\n\tcolor: rgba(0, 0, 0, 0.75);\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tmargin-top: 24px;\n}\n\n.app-page-container-cookie-button {\n\tpadding: 8px 16px;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: 'Inter', sans-serif;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-color: #69008c;\n\tborder-radius: 8px;\n\tmargin-top: 30px;\n\tmargin-right: 20px;\n}\n\n.app-page-container-cookie-button:hover,\n.app-page-container-cookie-button:focus {\n\tbackground: rgba(105, 0, 140, 0.4) !important;\n\tborder: none !important;\n}\n\n.app-page-container-cookie-button:active {\n\tbackground-color: #69008c !important;\n\tborder: none !important;\n}\n\n.app-page-container-cookie-button-con {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-top: 32px;\n}\n\n.app-btn-cookies-margin {\n\tmargin-right: 24px;\n}\n\n.app-table-imgPath .ant-table-wrapper .ant-table-tbody > tr > th,\n.app-table-imgPath .ant-table-wrapper .ant-table-tbody > tr > td {\n\tpadding: 0px 16px !important;\n\tline-height: 67px !important;\n}\n\n.app-table {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n}\n\n.app-table-content {\n\tbackground: #ffffff;\n\tborder-radius: 4px;\n\tflex: 1;\n\tpadding: 8px 8px 0 8px;\n\toverflow: hidden;\n}\n\n.app-page-container-cookie-display-none {\n\tdisplay: none;\n}\n\n.app-btn-min-width {\n\tmin-width: 72px;\n}\n\n.app-search-select-style {\n\theight: 35px;\n\twidth: 200px;\n\tmargin-right: 32px;\n\tmargin-bottom: 10px;\n}\n\n.app-list-date-style {\n\tmargin-bottom: 2px;\n\twhite-space: nowrap;\n}\n\n.app-modal-common {\n\tbox-shadow: none;\n\theight: auto;\n}\n\n.app-box-cursor-common {\n\tcursor: pointer;\n}\n\n.cursor-default-com {\n\tcursor: default;\n}\n\n.ant-table .ant-checkbox-checked:hover .ant-checkbox-inner {\n\tbackground-color: #6c5ce7 !important;\n\tborder-color: #6c5ce7 !important;\n}\n\n.app-category {\n\tmargin-top: 32px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tmargin-bottom: 32px;\n}\n\n.app-category-new {\n\tmargin-top: 18px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tmargin-bottom: 24px;\n}\n\n.app-category-title-con {\n\ttext-align: center;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\theight: 31px;\n\twidth: 100px;\n\tmargin-right: 24px;\n\tcolor: rgba(0, 0, 0, 0.25);\n}\n\n.app-category-title-border {\n\tborder-bottom: 2px solid #5f09e0;\n\tcolor: #5f09e0;\n}\n\n.app-professional {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.app-margintop {\n\tmargin-top: -15px;\n}\n\n.app-search-select-margin-top {\n\tmargin-top: 24px;\n}\n\n.table-line-all {\n\twidth: 100%;\n\tborder-top: 1px solid #e5e5e5;\n}\n\n.app-delete-modal {\n\tpadding-top: 32px;\n\tcolor: #000;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 20px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\tpadding-right: 32px;\n}\n\n.action-icon-size-all-con {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 4px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n}\n\n.action-icon-size-all {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.action-icon-size-all-con:hover {\n\tbackground: #eff3f6;\n}\n\n.action-btn-con {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n}\n\n/******** Filter styles *******/\n\n.app-filter-section {\n\tbackground-color: #ffffff;\n\tpadding: 16px 8px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.app-filter-section .filter-items-row {\n\tdisplay: flex;\n\tgap: 24px;\n\theight: 32px;\n\tflex: 1;\n}\n\n.filter-actions {\n\tflex: 1;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.flex-2 {\n\tflex: 2;\n}\n\n.filter-actions button {\n\tmargin-right: 11px;\n\tdisplay: inline-flex;\n\tpadding: 12px 24px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 4px;\n\tborder-radius: 17px;\n}\n\n.app-filter-section .filter-item {\n\tdisplay: flex;\n\tmin-width: 180px;\n\tjustify-content: space-between;\n\tflex: 1;\n\tpadding: 0px;\n\tflex-shrink: 0;\n}\n\n.app-filter-section .ant-picker-outlined {\n\tdisplay: flex;\n\tflex: 1;\n\tmin-width: 180px;\n\tborder: 1px solid #b6b6b6 !important;\n\tborder-radius: 8px;\n}\n\n.app-filter-section .text-input {\n\tpadding: 0px 11px !important;\n}\n.app-filter-section .text-input .ant-input {\n\tpadding: 0px !important;\n\theight: 32px !important;\n}\n\n.app-filter-section .filter-top-row .ant-select :nth-last-child {\n\tmargin-right: 0px;\n}\n\n.app-filter-section .filter-bottom-row .ant-select-selector {\n\tborder: none !important;\n}\n\n/********** antd styles override ************/\n\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n\tcolor: #5f09e0 !important;\n}\n.ant-tabs .ant-tabs-ink-bar {\n\tbackground-color: #5f09e0 !important;\n}\n\n.ant-tabs .ant-tabs-tab:hover {\n\tcolor: #5f09e0 !important;\n}\n\n@media (max-width: 768px) {\n\t.ant-layout-sider {\n\t\tposition: fixed !important;\n\t\theight: 100vh;\n\t\tz-index: 100;\n\t}\n\n\t.ant-layout {\n\t\tmargin-left: 0 !important;\n\t}\n\n\t.ant-layout-header {\n\t\tpadding: 0 16px !important;\n\t}\n}\n\n.ant-radio-wrapper .ant-radio-checked::after {\n\tborder-color: #5f09e0 !important;\n}\n\n.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n\tborder-color: #5f09e0 !important;\n\tbackground-color: #5f09e0 !important;\n}\n\n.ant-checkbox-group .ant-row {\n\tmargin-bottom: 8px;\n}\n.ant-checkbox-group .ant-row:first-child {\n\tmargin-top: 8px;\n}\n\n.ant-upload-drag {\n\tbackground-color: #fff !important;\n}\n\n.ant-breadcrumb,\n.ant-breadcrumb-link,\n.ant-breadcrumb-link:hover {\n\tcolor: #000 !important;\n\tfont-family: 'Segoe UI', sans-serif !important;\n\tfont-size: 20px !important;\n\tfont-style: normal !important;\n\tfont-weight: 700 !important;\n\tline-height: normal !important;\n\tbackground-color: transparent !important;\n}\n\n.ant-breadcrumb .ant-breadcrumb-separator {\n\tcolor: #000 !important;\n\tpadding: 0 !important;\n\tmargin: 0px !important;\n}\n\n.ant-modal .ant-modal-content {\n\tborder-radius: 4px !important;\n\tpadding: 0 0 !important;\n}\n\n.ant-modal .ant-modal-header {\n\tdisplay: flex !important;\n\talign-items: flex-start;\n\tpadding: 24px 24px 0 32px !important;\n}\n\n.ant-modal .ant-modal-body {\n\tpadding: 0 32px !important;\n\tmargin: 48px 0 !important;\n}\n\n.ant-modal .ant-modal-close {\n\ttop: 24px !important;\n\tright: 24px !important;\n\twidth: 24px !important;\n\theight: 24px !important;\n}\n\n.ant-modal .ant-modal-close:hover {\n\tbackground: transparent !important;\n}\n\n.app-modal-close-btn {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.ant-modal .ant-modal-title {\n\tfont-size: 32px !important;\n\tfont-weight: 500 !important;\n\tfont-style: Medium !important;\n\tcolor: #000 !important;\n\tvertical-align: middle !important;\n\tline-height: 28px !important;\n\tletter-spacing: 0px !important;\n\tfont-family: 'Henkel GT Flexa', sans-serif !important;\n}\n\n.ant-form-item .ant-form-item-label {\n\tpadding-bottom: 0px !important;\n}\n\n.ant-form-item .ant-form-item-label > label {\n\theight: 12px !important;\n\tmargin: 0 !important;\n\tpadding: 0 !important;\n\tcolor: #696969 !important;\n\tfont-family: 'Segoe UI', sans-serif !important;\n\tfont-size: 12px !important;\n\tfont-weight: 400 !important;\n\tpadding-left: 8px !important;\n\tline-height: 12px !important;\n\tpadding-bottom: 4px !important;\n}\n\n.ant-form-item .ant-form-item-explain-error {\n\tfont-family: 'Segoe UI', sans-serif !important;\n\tfont-size: 12px !important;\n\tfont-style: normal !important;\n\tfont-weight: 400 !important;\n\tline-height: 12px !important;\n\tpadding-left: 8px !important;\n}\n\n.ant-input {\n\tborder-radius: 4px !important;\n\theight: 34px !important;\n\tbox-shadow: none !important;\n\tpadding: 10px 8px !important;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif !important;\n\tfont-weight: 400 !important;\n\tfont-style: Regular !important;\n\tfont-size: 14px !important;\n\tline-height: 100%;\n\tletter-spacing: 0px !important;\n\tvertical-align: middle !important;\n}\n\n.ant-input-outlined {\n\tborder: 1px solid #b6b6b6 !important;\n}\n\n.ant-input:placeholder-shown {\n\tcolor: #b5b5b5 !important;\n}\n\n.ant-input:hover,\n.ant-input:focus {\n\tborder-color: #5f09e0 !important;\n\tbox-shadow: none !important;\n}\n\n.ant-input:focus {\n\tcolor: #000000 !important;\n}\n.ant-btn-color-purple.ant-btn-variant-solid {\n\tbackground-color: #5f09e0 !important;\n}\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover,\n.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus {\n\tborder-color: #cc3939 !important;\n}\n\n.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled) {\n\tborder-color: #cc3939 !important;\n}\n\n.ant-form-item .ant-form-item-explain-error {\n\tcolor: #cc3939 !important;\n}\n\n.ant-form-item {\n\tmargin-bottom: 18px !important;\n}\n\n.ant-modal .ant-modal-footer {\n\tdisplay: flex !important;\n\talign-items: center !important;\n\tjustify-content: center !important;\n\tpadding-bottom: 48px !important;\n}\n\n.app-btn-cancel-margin-right {\n\tmargin-right: 48px;\n}\n\n.ant-pagination .ant-pagination-item {\n\theight: 32px !important;\n\tpadding: 5px 12px !important;\n\tgap: 10px !important;\n\tborder-radius: 2px !important;\n\tborder: 1px solid #e4e7ed !important;\n\tbackground: #f5f7fa !important;\n}\n\n.ant-pagination .ant-pagination-item a {\n\tcolor: #909399 !important;\n\ttext-align: center !important;\n\tfont-family: 'Segoe UI', sans-serif !important;\n\tfont-size: 14px !important;\n\tfont-style: normal !important;\n\tfont-weight: 400 !important;\n\tline-height: normal !important;\n\tpadding: 0px !important;\n}\n\n.ant-pagination .ant-pagination-item-active {\n\tbackground-color: #ffffff !important;\n\tborder-color: #5f09e0 !important;\n}\n\n.ant-pagination .ant-pagination-item-active a {\n\tcolor: #5f09e0 !important;\n\tfont-weight: 700 !important;\n}\n\n.ant-pagination .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination .ant-pagination-next .ant-pagination-item-link {\n\tborder: 1px solid #e4e7ed !important;\n\tbackground: #f5f7fa !important;\n\tborder-radius: 2px !important;\n}\n\n.ant-pagination .ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {\n\tbackground-color: #f5f7fa !important;\n\tborder-radius: 2px !important;\n\tborder: 1px solid #e4e7ed !important;\n}\n\n.ant-select-single .ant-select-selector {\n\tborder-radius: 8px !important;\n\tborder: 1px solid var(--N2-Grey-696969, #696969) !important;\n}\n\n.css-dev-only-do-not-override-1v28nim.ant-picker-outlined {\n\tborder-radius: 8px !important;\n\theight: 34px;\n}\n\n.ant-padding-new {\n\tpadding: 8px 16px;\n}\n\n.ant-top-margin-top {\n\tmargin-top: 32px;\n}\n\n.css-dev-only-do-not-override-1v28nim.ant-picker-dropdown\n\t.ant-picker-cell-in-view.ant-picker-cell-in-range:hover::before {\n\tbackground-color: #e1d0fc !important;\n}\n\n.ant-table-wrapper .ant-table-tbody > tr > td {\n\tborder-bottom: none !important;\n\tpadding: 8px 16px !important;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif;\n\tfont-weight: 400 !important;\n\tfont-style: Regular !important;\n\tfont-size: 14px !important;\n\tline-height: 100% !important;\n\tletter-spacing: 0px !important;\n\tvertical-align: middle !important;\n\tcolor: #3b3b3b !important;\n}\n\n.ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {\n\tbackground: #fbf9f9 !important;\n}\n\n.ant-table-tbody .ant-table-row {\n\theight: 56px !important;\n}\n\n.ant-table-wrapper .ant-table {\n\toverflow: hidden !important;\n}\n.ant-table-header .ant-table-thead {\n\tbackground-color: #e0f6f8 !important;\n}\n\n.ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {\n\twidth: 0px !important;\n\tpadding: 0px !important;\n}\n\ntable > thead > tr:first-child > .ant-table-cell-fix-right {\n\tborder-start-end-radius: 4px !important;\n\tborder-bottom-right-radius: 4px !important;\n\ttext-align: center;\n}\n\n.ant-table-thead > tr {\n\tfont-family: 'Segoe UI', 'sans-serif' !important;\n\tfont-weight: 550 !important;\n\tfont-style: Semibold !important;\n\tfont-size: 12px !important;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\ttext-align: center;\n\tvertical-align: middle;\n\tborder-radius: 4px !important;\n\theight: 56px !important;\n}\n\n.ant-table-thead > tr > th {\n\tbackground: #e0f6f8 !important;\n\tpadding: 12px 16px !important;\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th,\n.ant-table-wrapper .ant-table-thead > tr > td {\n\tborder-bottom: none !important;\n}\n\ntable > thead > tr:first-child > *:first-child {\n\tborder-start-start-radius: 4px !important;\n\tborder-bottom-left-radius: 4px !important;\n}\n\n.ant-table-measure-row {\n\tdisplay: none !important;\n}\n\n.ant-table-row-selected {\n\tbackground-color: #fff !important;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected td {\n\tbackground-color: #fff !important;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected:hover td {\n\tbackground-color: #fff !important;\n}\n\n.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: 1px solid #b6b6b6 !important;\n\tbox-shadow: none !important;\n}\n\n.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover\n\t.ant-select-selector {\n\tborder-color: #5f09e0 !important;\n\tbox-shadow: none !important;\n}\n\n.ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(\n\t\t.ant-pagination-size-changer\n\t)\n\t.ant-select-selector {\n\tborder-color: #5f09e0 !important;\n\tbox-shadow: none !important;\n}\n\n.ant-select-dropdown {\n\tpadding: 8px !important;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif !important;\n\tfont-weight: 400 !important;\n\tfont-style: Regular !important;\n\tfont-size: 14px !important;\n}\n\n.ant-select-dropdown .ant-select-item {\n\theight: 36px !important;\n\tborder-radius: 4px !important;\n\tmargin-bottom: 4px;\n}\n\n.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n\tbackground: #efe6fc !important;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif !important;\n\tfont-weight: 400 !important;\n\tfont-style: Regular !important;\n\tfont-size: 14px !important;\n}\n\n.ant-select-dropdown\n\t.ant-select-item-option-selected:not(.ant-select-item-option-disabled)\n\t.ant-select-item-option-state {\n\tcolor: #5f09e0 !important;\n}\n\n.ant-select-outlined.ant-select-multiple .ant-select-selection-item {\n\tbackground: #eff3f6 !important;\n\theight: 26px !important;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif !important;\n\tfont-weight: 400 !important;\n\tfont-style: Regular !important;\n\tfont-size: 14px !important;\n\tline-height: 24px !important;\n\tletter-spacing: 0% !important;\n\tvertical-align: middle !important;\n\tborder-radius: 4px !important;\n}\n\n.ant-menu .ant-menu-submenu-title {\n\tborder-radius: none !important;\n}\n\n.footer-main-con {\n\tmin-height: calc(100vh - 80px);\n\tpadding: 40px 100px 100px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif;\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tletter-spacing: 0%;\n\tcolor: #3b3b3b;\n}\n\n.footer-mian-top-icon {\n\twidth: 88px;\n\theight: 65px;\n\tmargin-bottom: 40px;\n}\n\n.footer-main-top-title {\n\ttext-align: center;\n\tfont-weight: 500;\n\tfont-size: 20px;\n\tmargin-bottom: 40px;\n}\n\n.footer-main-blod {\n\tfont-weight: 700;\n}\n\n.footer-main-con ul,\n.footer-main-con ol {\n\tmargin-left: 20px;\n}\n\n.footer-main-con a {\n\ttext-decoration: underline;\n\tcolor: #3b3b3b;\n}\n\n.footer-main-con a:hover {\n\ttext-decoration: underline;\n\tcolor: #3b3b3b;\n\tfont-weight: 500;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n\tbackground-color: #5f09e0 !important;\n\tborder-color: #5f09e0 !important;\n}\n.ant-checkbox-checked .ant-checkbox-inner:after {\n\tbackground-color: #5f09e0 !important;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n\tborder-color: #5f09e0 !important;\n}\n.ant-checkbox .ant-checkbox-input:hover {\n\tborder-color: #5f09e0 !important;\n}\n.ant-picker-ranges .ant-btn-variant-solid {\n\tbackground-color: #5f09e0 !important;\n\tborder-color: #5f09e0 !important;\n\tcolor: #fff !important;\n}\n/* .ant-picker-range {\n\theight: 32px !important;\n} */\n\n.ant-picker-dropdown\n\t.ant-picker-time-panel-column\n\t> li.ant-picker-time-panel-cell-selected\n\t.ant-picker-time-panel-cell-inner {\n\twidth: 140%;\n\tbackground-color: #e1d0fc !important;\n\tmargin-left: -10px;\n}\n.ant-picker-outlined:hover {\n\tborder-color: #5f09e0 !important;\n}\n\n.ant-picker-outlined:focus,\n.ant-picker-outlined-focused,\n.ant-picker-outlined:focus-within {\n\tborder: 1px solid #5f09e0 !important;\n\tbox-shadow: none !important;\n\toutline: none !important;\n}\n\n.ant-picker-outlined .ant-picker-input input::after {\n\tborder-bottom-color: #5f09e0 !important;\n}\n\n.ant-picker-outlined .ant-picker-input-focused::after,\n.ant-picker-outlined-focused .ant-picker-input::after {\n\tborder-bottom-color: #5f09e0 !important;\n\tborder-bottom-width: 2px !important;\n}\n.ant-picker-active-bar {\n\tbackground-color: #5f09e0 !important;\n}\n.ant-dropdown-menu-item img {\n\twidth: 22px;\n\theight: 22px;\n\tmargin-left: -2px;\n}\n\n.ant-tree .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {\n\tbackground-color: #5f09e0 !important;\n}\n\n.ant-tree .ant-tree-checkbox-checked .ant-tree-checkbox-inner {\n\tbackground-color: #5f09e0 !important;\n\tborder-color: #5f09e0 !important;\n}\n\n.delete-confirm-modal .ant-modal-content .ant-modal-body {\n\tmargin: 0px !important;\n\tpadding: 32px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
